<template>
  <ul :class="['header-links', 'text-xs-center']">
    <li v-for="(link, index) in headerMenu" :key="index">
      <v-btn :to="link.url" :title="link.hint" :class="['ma-0']" flat large>{{ link.label }}</v-btn>
    </li>
  </ul>
</template>
<script>
import headerMenu from '../helpers/menu'

export default {
  name: 'HeaderLinks',
  data () {
    return {
      headerMenu
    }
  }
}
</script>
<style>
.header-links,
.header-links li
{
  margin: 0;
  padding: 0;
  list-style: none;
}

.header-links
{
  width: 100%;
  white-space: nowrap;
}

.header-links li
{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/header-links.vue